import { message } from 'antd';
import { useMutation, useQueryClient } from 'react-query';

import { useApi } from '../../context/ApiContext';
import { useTenant } from '../../context/TenantContext';

export const useUpdateMultiAccessUser = (userId) => {
  const client = useApi();
  const queryClient = useQueryClient();
  const { env } = useTenant();

  return useMutation(
    (values) =>
      client.put(`${env.REACT_APP_BACKEND_PORTAL_URL}/users/multi-access/${userId}`, values).then((res) => res.data),
    {
      onSuccess() {
        queryClient.invalidateQueries(['get-multi-access-kam-info', userId]);
        queryClient.invalidateQueries(['get-multi-access-users', userId]);
        queryClient.invalidateQueries('get-kam-contract-list');
        queryClient.invalidateQueries('get-multi-access-users');
      },
      onError() {
        message.error('Request failed to update the user');
      },
    },
  );
};
